import React, { useState, useContext, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import LayerCard from "./LayerCard";
import { ModalMain, SelectLayersTitle, DropdownOption, SelectLayersDescription, AddLayerButton } from "./styled";
import { DateFilterContext } from "../context";
import { ActionLayerKind } from "../reducers";
import { useLayerData, getDateLayerAttributes, getDataLayerAggregationAttributes } from "../hooks";

export default () => {
  const { t } = useTranslation("dateFilter");
  const [ref, setRef] = useState(null);
  const { formLayers: layers, formLayerDispatcher: layerDispatcher } = useContext(DateFilterContext);
  const { layersData, loading } = useLayerData();

  const options = useMemo(() => {
    if (!layersData) {
      return;
    }
    const layerOptions = layersData.map(layerData => ({
      value: layerData.alias,
      text: <DropdownOption mute={!layerData.isVisible}>{layerData.alias}</DropdownOption>,
      id: layerData.name,
      attributes: getDateLayerAttributes(layerData),
      aggregationAttributes: getDataLayerAggregationAttributes(layerData),
    }));

    layers.forEach(layer => {
      if (!layerOptions.find(({ id }) => id === layer.id)) {
        layerDispatcher({
          type: ActionLayerKind.UpdateLayer,
          payload: {
            data: { ...layer, attributes: [], attribute: null, aggregationAttributes: [] },
            index: layer.uniqueId,
          },
        });
      }
    });

    return layerOptions;
  }, [layersData]);

  const refState = useCallback(node => {
    if (node !== null) {
      setRef(node);
    }
  }, []);

  return (
    <ModalMain ref={refState}>
      <SelectLayersTitle>{t("indicateLayers")}</SelectLayersTitle>
      <SelectLayersDescription>{t("indicateLayersDescription")}</SelectLayersDescription>
      {layers.map(layer => (
        <LayerCard
          key={layer.uniqueId}
          layer={layer}
          options={options}
          dialogContainer={ref}
          loadingOptions={loading}
        />
      ))}
      <AddLayerButton
        kind="feature_add"
        onClick={() => {
          layerDispatcher({ type: ActionLayerKind.AddLayer });
        }}
      >
        {t("addLayer")}
      </AddLayerButton>
    </ModalMain>
  );
};
